import { RootState } from "../store/store";
import { Avatar, Flex, Button, Drawer, Tooltip, Grid, Dropdown } from "antd";
import { useSelector } from "react-redux";

import { Logout } from "./Logout";
import Logo from "./Logo";
import { useState } from "react";

import {
  IconDotsVertical,
  IconSettings2,
  IconLayoutSidebarLeftExpandFilled,
} from "@tabler/icons-react";
import { IconLayoutSidebarRightExpandFilled } from "@tabler/icons-react";
import { SideBarItem } from "./siderbar/SideBar";
import { Link, useNavigate, useParams } from "react-router";
import { ROUTES } from "../constants/routes.constant";
import placeholder from "../assets/placeholder_thumbnail.png";

const Navbar = () => {
  const user = useSelector((store: RootState) => store.user);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const breakpoints = Grid.useBreakpoint();
  const { id } = useParams();

  return (
    <>
      <div className="sticky top-0 h-[72px] px-[16px] flex justify-between items-center border-b border-b-gray-100 z-[100] bg-white">
        <div className="flex items-center gap-16 md:gap-[30px] text-black">
          {id && (
            <>
              <Button
                color="default"
                variant="filled"
                shape="circle"
                className="flex! lg:!hidden"
                onClick={() => setOpen(true)}
                icon={<IconLayoutSidebarLeftExpandFilled size={18} />}
              />

              {/* <div className=' !block lg:!hidden border border-gray-0200 h-20'></div> */}
            </>
          )}

          <Link to="/">
            <Logo InHeader size={60} />
          </Link>
        </div>

        {breakpoints.md ? (
          <Flex className="" align="center" gap={10}>
            <Tooltip title="Profile">
              <Link to={ROUTES.MY_PROFILE.path}>
                {user?.profile_picture &&
                Array.isArray(user?.profile_picture) &&
                user.profile_picture.length > 0 ? (
                  <Avatar
                    src={
                      user?.profile_picture &&
                      Array.isArray(user?.profile_picture)
                        ? user?.profile_picture?.[0]?.url
                        : placeholder
                    }
                    alt={user?.first_name}
                    size={38}
                    className="ff-title font-bold uppercase"
                  />
                ) : (
                  <Avatar
                    src={placeholder}
                    size={38}
                    className="ff-title font-bold uppercase"
                  />
                )}
              </Link>
            </Tooltip>
            {!user?.workspace?.role ||
            user?.workspace?.role === "owner" ||
            user?.workspace?.role === null ? (
              <Tooltip title="Page settings">
                <Button
                  // type="link"
                  shape="circle"
                  color="default"
                  variant="filled"
                  icon={<IconSettings2 size={18} />}
                  onClick={() => navigate(ROUTES.WORKSPACE_SETTING.path)}
                />
              </Tooltip>
            ) : (
              <></>
            )}

            <Logout text="Logout" type="text" />
          </Flex>
        ) : (
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  label: <Link to={ROUTES.MY_PROFILE.path}>My Profile</Link>,
                },

                {
                  key: "2",
                  label: (
                    <Link to={ROUTES.WORKSPACE_SETTING.path}>
                      Page Settings
                    </Link>
                  ),
                },
                {
                  key: "3",
                  label: <Logout text="Logout" type="indropdown" />,
                },
              ],
            }}
          >
            <Button
              shape="circle"
              variant="filled"
              color="default"
              icon={<IconDotsVertical size={16} />}
            />
          </Dropdown>
        )}
      </div>

      <Drawer
        closable={false}
        onClose={() => setOpen(false)}
        open={open}
        placement="left"
        width={280}
      >
        <header className="py-[8px] px-[16px] flex  border-b border-gray-200 justify-between  items-center">
          <Link to="/">
            <Logo InHeader size={48} />
          </Link>
          <Button
            type="text"
            className="!flex lg:!hidden"
            onClick={() => setOpen(false)}
            icon={
              <IconLayoutSidebarRightExpandFilled color="var(--primary-text-color)" />
            }
          />
        </header>
        <div className="flex gap-10 flex-col">
          <SideBarItem setOpen={setOpen} />
        </div>
      </Drawer>
    </>
  );
};

export default Navbar;
